import styled, { css } from 'styled-components';
import { TGridLayouts } from './MediasSection';
import { medias } from '../../../utils/sizes';

export const ImageContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => !['imageOrder'].includes(prop),
})<{
  imageOrder: number;
}>`
  position: relative;
  overflow: hidden;

  > div {
    height: 100%;
  }

  img {
    cursor: zoom-in;
  }

  &.medias-image-container {
    cursor: zoom-in;
  }

  .medias-section-image {
    pointer-events: none !important;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    pointer-events: none;
    -webkit-user-drag: none;
  }

  // SOLO PARA DEBUGGEAR, DESCOMENTAR PARA VER LOS NÚMEROS DE ORDEN
  /* &:after {
    ${(props) => `content: '${props.imageOrder + 1}';`}
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 45px;
    width: 45px;
    background: blue;
    color: white;
    border-radius: 25px;
    line-height: 25px;
    font-size: 25px;
    top: 50%;
    left: 50%;
    opacity: 1;
    transform: translate(-50%, -50%);
  } */
`;

export const MediasSectionContainer = styled.div.withConfig({
  shouldForwardProp: (prop) =>
    !['gridLayout', 'isInTwoColLayout'].includes(prop),
})<{
  gridLayout: TGridLayouts | undefined;
  isInTwoColLayout?: boolean;
}>`
  display: grid;
  grid-gap: var(--spacing-component-inner);
  overflow: hidden;

  ${ImageContainer} > div {
    aspect-ratio: inherit;
    width: 100%;
    height: 100%;
    position: relative;

    iframe {
      position: absolute;
      min-width: 100%;
      min-height: 100%;
      height: 100% !important;
      width: auto !important;
      left: 50% !important;
      top: 50% !important;
      transform: translate(-50%, -50%);
    }
  }

  ${(isInTwoColLayout) =>
    isInTwoColLayout &&
    css`
      grid-template-columns: 100%;
    `}

  // TYPE 2-col--2-imgs 2:1
    ${(props) =>
    props.gridLayout === 'K_2-col--2-imgs-2:1' &&
    css`
      grid-template-columns: repeat(2, 1fr);

      ${ImageContainer} {
        aspect-ratio: 2 / 1;
      }

      ${medias.max.mobile} {
        display: flex;
        flex-direction: column;
      }
    `}

    // TYPE 2-col--2-imgs 16:9
    ${(props) =>
    props.gridLayout === 'L_2-col--2-imgs-16:9' &&
    css`
      grid-template-columns: repeat(2, 1fr);

      ${ImageContainer} {
        aspect-ratio: 16 / 9;
      }

      ${medias.max.mobile} {
        display: flex;
        flex-direction: column;
      }
    `}

    // TYPE 2-col--2-imgs 1:1
    ${(props) =>
    props.gridLayout === 'M_2-col--2-imgs-1:1' &&
    css`
      grid-template-columns: repeat(2, 1fr);

      ${ImageContainer} {
        aspect-ratio: 1 / 1;
      }

      ${medias.max.mobile} {
        display: flex;
        flex-direction: column;
      }
    `}

    // TYPE 3-col-3-imgs
    ${(props) =>
    props.gridLayout === 'O_3-col--3-imgs' &&
    css`
      grid-template-columns: repeat(3, 1fr);

      ${ImageContainer} {
        aspect-ratio: 4 / 5;
      }

      ${medias.max.mobile} {
        display: flex;
        flex-direction: column;
      }
    `}

    // TYPE 3-col--5-imgs
    ${(props) =>
    props.gridLayout === 'R_3-col--5-imgs' &&
    css`
      grid-template-columns: repeat(4, auto);

      ${ImageContainer} {
        aspect-ratio: 1 / 1;
      }

      ${ImageContainer}:nth-of-type(3) {
        grid-column: span 2;
        grid-row: span 2;
      }

      ${medias.max.mobile} {
        grid-template-columns: repeat(2, auto);

        ${ImageContainer}:nth-of-type(3) {
          grid-row-start: 3;
        }
      }
    `}

    // TYPE 2-col--4-imgs-reverse
    ${(props) =>
    props.gridLayout === 'P_2-col--4-imgs-right' &&
    css`
      grid-template-columns: repeat(4, 1fr);

      ${ImageContainer}:nth-of-type(1) {
        aspect-ratio: 4 / 3;
        grid-row: 1;
        grid-column: 1 / 3;
      }

      ${ImageContainer}:nth-of-type(3),
      ${ImageContainer}:nth-of-type(4) {
        grid-column-start: 1;
        aspect-ratio: 1 / 1;
        grid-row-start: 2;
      }

      ${ImageContainer}:nth-of-type(4) {
        grid-column-start: 2;
      }

      //
      ${ImageContainer}:nth-of-type(2) {
        aspect-ratio: 4 / 5;
        grid-column: 3 / 5;
        grid-row: 1 / 3;
        width: 100%;
        height: 100%;
      }

      ${medias.max.mobile} {
        grid-template-columns: 1fr 1fr;

        ${ImageContainer}:nth-of-type(1) {
          grid-column: 1 / 3;
          grid-column-start: 1;
        }

        ${ImageContainer}:nth-of-type(2) {
          grid-column: 1 / 3;
          grid-row-start: 2;
        }

        ${ImageContainer}:nth-of-type(3) {
          grid-column-start: 1;
        }

        ${ImageContainer}:nth-of-type(4) {
          grid-column: 2 / 3;
        }

        ${ImageContainer}:nth-of-type(3),
        ${ImageContainer}:nth-of-type(4) {
          aspect-ratio: 1 / 1;
          grid-row: 3;
        }
      }
    `}

    // TYPE 2-col--4-imgs
    ${(props) =>
    props.gridLayout === 'Q_2-col--4-imgs' &&
    css`
      grid-template-columns: repeat(4, 1fr);

      ${ImageContainer}:nth-of-type(1) {
        aspect-ratio: 4 / 5;
        grid-column: 1 / 3;
        grid-row: 1 / 3;
        width: 100%;
        height: 100%;
      }

      ${ImageContainer}:nth-of-type(2) {
        aspect-ratio: 4 / 3;
        grid-column: span 2;
      }

      ${ImageContainer}:nth-of-type(3),
      ${ImageContainer}:nth-of-type(4) {
        aspect-ratio: 1 / 1;
        grid-row: 2;
      }

      ${medias.max.mobile} {
        grid-template-columns: repeat(2, 1fr);

        ${ImageContainer}:nth-of-type(1) {
          grid-column: 1 / 3;
          grid-row: 1 / 2;
        }

        ${ImageContainer}:nth-of-type(2) {
          grid-column: 1 / 3;
          grid-row-start: 2;
        }

        ${ImageContainer}:nth-of-type(3),
        ${ImageContainer}:nth-of-type(4) {
          aspect-ratio: 1 / 1;
          grid-row: 3;
        }
      }
    `}

    // TYPE 2-col--3-imgs
    ${(props) =>
    props.gridLayout === 'N_2-col--3-imgs' &&
    css`
      grid-template-columns: repeat(2, 1fr);

      ${ImageContainer}:nth-of-type(1) {
        aspect-ratio: 3 / 2;
        grid-row: 1;
        grid-column: 1 / 2;
      }

      ${ImageContainer}:nth-of-type(3) {
        aspect-ratio: 3 / 2;
        grid-row: 2;
        grid-column: 1 / 2;
      }

      ${ImageContainer}:nth-of-type(2) {
        aspect-ratio: 3 / 4;
        grid-row: 1 / 3;
        height: 100%;
      }

      ${medias.max.mobile} {
        grid-template-columns: 1fr 1fr;

        ${ImageContainer}:nth-of-type(3) {
          grid-row: 2;
        }

        ${ImageContainer}:nth-of-type(1) {
          grid-row: 1;
        }

        ${ImageContainer}:nth-of-type(2) {
          grid-column-start: 2;
          grid-row: 1 / 3;
        }
      }
    `}

    // TYPE 1-col--1-img
    ${(props) =>
    props.gridLayout === 'C_1-col--1-img-2:1' &&
    css`
      display: flex;

      ${ImageContainer} {
        width: 100%;
        aspect-ratio: 2 / 1;
      }
    `}

    // TYPE 1-col--1-img-16:9
    ${(props) =>
    props.gridLayout === 'D_1-col--1-img-16:9' &&
    css`
      display: flex;

      ${ImageContainer} {
        width: 100%;
        aspect-ratio: 16 / 9;
      }
    `}

    ${(props) =>
    (props.gridLayout === 'E_1-img-2:1-left' ||
      props.gridLayout === 'F_1-img-2:1-right') &&
    css`
      ${ImageContainer} {
        width: 100%;
        aspect-ratio: 2 / 1;
      }
    `}

    ${(props) =>
    (props.gridLayout === 'G_1-img-16:9-left' ||
      props.gridLayout === 'H_1-img-16:9-right') &&
    css`
      ${ImageContainer} {
        width: 100%;
        aspect-ratio: 16 / 9;
      }
    `}
`;
